import { DataBean } from "../DataBean";

export class FinancialMovementTax extends DataBean {



    public async getFinancialMovementTaxReport(idEmployee: any, processType: any, year: any, month: any, state: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFinancialMovementTaxReport_Number_Number_Number_Number_Number_String_Number_Number", [idEmployee, processType, year, month, state, regexStr, page, recordsPerPage]);
    }

    public async getFinancialMovementTaxReportForTreasure(idEmployee: any, processType: any, year: any, month: any, state: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFinancialMovementTaxReportForTreasure_Number_Number_Number_Number_Number_String_Number_Number", [idEmployee, processType, year, month, state, regexStr, page, recordsPerPage]);
    }
    public async deleteFinancialMovementTax(idFinancialMovementTax: any, accountantDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteFinancialMovementTax_Number_java.util.Date", [idFinancialMovementTax, accountantDate]);
    }

    public async updateFinancialMovementTax(bean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.tax.FinancialMovementTax_updateFinancialMovementTax_com.quickdataerp.bean.tax.FinancialMovementTax", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.tax.FinancialMovementTax"
            }
        ]);
    }

}